// extracted by mini-css-extract-plugin
export default {"ready":"v3nxH","message":"KrSeB"};